import React from "react";
import { findAllAcademicPartWithFormTemplateNotIncludeBySemesterEvent } from "../../_events/academic_parts/find.event";
import { alertError } from "../../_utils/alerts";

export const useAcademicPartAllFormTemplateNotIncludeBySemester = (semester) => {

    const [data, setData] = React.useState([]);

    const loadData = (s) => {
        findAllAcademicPartWithFormTemplateNotIncludeBySemesterEvent(s)
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(semester);
    }, [semester]);

    return { data, loadData };
}